import { Card, Progress, Typography } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

interface PeriodInfoProps {
  readonly periodStart: string;
  readonly periodDays: number;
}

export function PeriodInfo({ periodStart, periodDays }: PeriodInfoProps) {
  const start = dayjs(periodStart);
  const end = start.add(periodDays, "day");
  const today = dayjs();
  const daysRemaining = Math.max(0, end.diff(today, "day"));
  const daysElapsed = Math.min(
    periodDays,
    Math.max(0, periodDays - daysRemaining),
  );
  const elapsedPercent =
    periodDays > 0 ? Math.round((daysElapsed / periodDays) * 100) : 0;

  return (
    <Card className="crow-card" bordered>
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <Text className="!text-[11px] !font-semibold !uppercase !tracking-[0.12em] !text-content-tertiary">
            Billing period
          </Text>
          <div className="text-lg font-semibold text-content-primary mt-1">
            {start.format("MMM D, YYYY")}{" "}
            <span className="text-content-tertiary mx-1">→</span>{" "}
            {end.format("MMM D, YYYY")}
          </div>
        </div>
        <div className="text-right">
          <Text className="!text-[11px] !font-semibold !uppercase !tracking-[0.12em] !text-content-tertiary">
            Days remaining
          </Text>
          <div className="text-lg font-semibold text-content-primary mt-1">
            <span className="text-accent">{daysRemaining}</span>
            <span className="text-content-tertiary text-sm"> / {periodDays}</span>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <Progress
          percent={elapsedPercent}
          showInfo={false}
          strokeColor="#6366F1"
          trailColor="rgba(17,24,39,0.06)"
        />
        <div className="flex justify-between mt-1 text-xs text-content-tertiary">
          <span>{daysElapsed} days elapsed</span>
          <span>{elapsedPercent}% through</span>
        </div>
      </div>
    </Card>
  );
}
